import React, { useEffect, useRef } from 'react';
import Link from 'shared/SlashLink';
import './WebDevPromo.css';

const CARDS = [
    {
        eyebrow: 'In a hurry?',
        title: 'Same Day Websites',
        text: 'A professional, mobile-ready site live in as little as 24 hours — starting at $499.',
        to: '/same-day-websites',
        cta: 'See same-day options',
    },
    {
        eyebrow: 'Just starting out?',
        title: 'Small Business Startup Package',
        text: 'Website, logo, domain, a year of hosting, 5 email accounts, and social setup — one bundle.',
        to: '/startup-package',
        cta: 'Explore the package',
    },
];

const WebDevPromo = () => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            // No observer (or SSR/prerender) — just reveal.
            el && el.querySelectorAll('.wdp_card').forEach((c) => c.classList.add('is-visible'));
            return;
        }
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
            });
        }, { threshold: 0.2 });
        el.querySelectorAll('.wdp_card').forEach((c) => io.observe(c));
        return () => io.disconnect();
    }, []);

    const onClick = () => window.scrollTo(10, 0);

    return (
        <div className="wdp_wrap" ref={ref}>
            <h3 className="details_item_info_title">Want to launch faster?</h3>
            <p className="mb-4">
                Not every project needs a full custom build. If you're moving fast or just getting started,
                these two get you online sooner — and you can always grow into a custom site later.
            </p>
            <div className="row">
                {CARDS.map((c) => (
                    <div className="col-md-6 mb-3" key={c.to}>
                        <Link to={c.to} onClick={onClick} className="wdp_card" aria-label={c.title}>
                            <span className="wdp_eyebrow">{c.eyebrow}</span>
                            <span className="wdp_title">{c.title}</span>
                            <span className="wdp_text">{c.text}</span>
                            <span className="wdp_cta">{c.cta} <i className="fa-solid fa-arrow-right wdp_arrow" aria-hidden="true"></i></span>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WebDevPromo;
